import { render } from "./contact-page.vue?vue&type=template&id=73f18d02"
import script from "./contact-page.vue?vue&type=script&lang=ts"
export * from "./contact-page.vue?vue&type=script&lang=ts"
script.render = render

export default script